(() => {
  const previousDisplayStyles = new WeakMap();
  const styleObservers = new WeakMap();
  const tourLauncherStyles = new WeakMap();

  const cartOpenSelector = ['#cart-notification.active', 'cart-drawer.active'].join(', ');
  const rewardsLauncherSelector = ['#smile-ui-container', '#smile-ui-lite-launcher-frame-container'].join(', ');

  const themePopupSelector = [
    'quick-add-modal[open]',
    'modal-dialog[open]',
    'product-modal[open]',
    'cart-disclosure-modal[open]',
    'pickup-availability[open]',
    'details-modal > details[open]',
    'product-size-chart [open]',
  ].join(', ');

  const setImportant = (element, property, value) => {
    if (element.style.getPropertyValue(property) === value && element.style.getPropertyPriority(property) === 'important') {
      return;
    }

    element.style.setProperty(property, value, 'important');
  };

  const observeDisplayStyle = (element) => {
    if (styleObservers.has(element)) return;

    const observer = new MutationObserver(positionWidget);
    observer.observe(element, { attributes: true, attributeFilter: ['style'] });
    styleObservers.set(element, observer);
  };

  const hideElement = (element) => {
    observeDisplayStyle(element);
    if (!previousDisplayStyles.has(element)) {
      previousDisplayStyles.set(element, {
        priority: element.style.getPropertyPriority('display'),
        value: element.style.getPropertyValue('display'),
      });
    }
    setImportant(element, 'display', 'none');
  };

  const restoreElement = (element) => {
    const previousDisplay = previousDisplayStyles.get(element);
    if (!previousDisplay) return;

    previousDisplayStyles.delete(element);
    if (previousDisplay.value) {
      element.style.setProperty('display', previousDisplay.value, previousDisplay.priority);
    } else {
      element.style.removeProperty('display');
    }
  };

  const positionWidget = () => {
    const pageType = document.getElementById('MainContent')?.dataset.template;
    const isCartOpen = pageType === 'cart' || Boolean(document.querySelector(cartOpenSelector));
    const isMobileTourPreorder = window.matchMedia('(max-width: 749px)').matches && Boolean(document.querySelector('.tour-preorder-page'));
    document.querySelectorAll(rewardsLauncherSelector).forEach((launcher) => {
      if (isCartOpen || isMobileTourPreorder) {
        hideElement(launcher);
      } else {
        restoreElement(launcher);
      }
    });

    const widget = document.getElementById('zeik0-widget-container');
    const iframe = widget?.querySelector('#zeik0-widget-iframe');
    if (!iframe) return false;

    observeDisplayStyle(widget);
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const isThemePopupOpen = Boolean(document.querySelector(themePopupSelector));
    const isStickyProductBarVisible = Boolean(document.querySelector('.sdna-sticky-product-bar.is-visible'));
    const isRewardsPage = Boolean(document.querySelector('.salty-rewards'));
    const iframeWidth = Number.parseFloat(iframe.style.width) || iframe.getBoundingClientRect().width;
    const iframeHeight = Number.parseFloat(iframe.style.height) || iframe.getBoundingClientRect().height;
    const isExpanded = iframeWidth > 200 || iframeHeight > 180;
    const isMobileFallTour = isMobile && Boolean(document.querySelector('seasonal-tour[data-active-season="fall"]'));

    if (isMobileFallTour && !isExpanded) {
      if (!tourLauncherStyles.has(widget)) {
        tourLauncherStyles.set(widget, ['transform', 'transform-origin'].map((property) => [
          property, widget.style.getPropertyValue(property), widget.style.getPropertyPriority(property),
        ]));
      }
      setImportant(widget, 'transform', 'scale(0.74)');
      setImportant(widget, 'transform-origin', '100% 100%');
    } else if (tourLauncherStyles.has(widget)) {
      tourLauncherStyles.get(widget).forEach(([property, value, priority]) => {
        if (value) widget.style.setProperty(property, value, priority);
        else widget.style.removeProperty(property);
      });
      tourLauncherStyles.delete(widget);
    }

    if (
      isCartOpen ||
      isMobileTourPreorder ||
      isThemePopupOpen ||
      (isMobile && pageType === 'product' && isStickyProductBarVisible)
    ) {
      hideElement(widget);
      return true;
    }

    restoreElement(widget);
    if (isMobile && isRewardsPage && !isExpanded) {
      setImportant(widget, 'width', '56px');
      setImportant(widget, 'height', '56px');
      setImportant(widget, 'min-width', '56px');
      setImportant(widget, 'min-height', '56px');
      setImportant(widget, 'overflow', 'hidden');
      setImportant(widget, 'border-radius', '12px');
      setImportant(widget, 'inset', 'auto 1.2rem 1.2rem auto');
      setImportant(iframe, 'transform', 'translate(-20px, -20px)');
    } else if (isMobile && isRewardsPage) {
      setImportant(widget, 'width', `${Math.min(iframeWidth, window.innerWidth)}px`);
      setImportant(widget, 'height', `${Math.min(iframeHeight, window.innerHeight)}px`);
      setImportant(widget, 'min-width', '0px');
      setImportant(widget, 'min-height', '0px');
      setImportant(widget, 'overflow', 'visible');
      widget.style.removeProperty('border-radius');
      setImportant(widget, 'inset', 'auto 0px 0px auto');
      setImportant(iframe, 'transform', 'none');
    } else if (isRewardsPage) {
      ['width', 'height', 'min-width', 'min-height', 'overflow', 'border-radius'].forEach((property) => {
        widget.style.removeProperty(property);
      });
      iframe.style.removeProperty('transform');
      setImportant(widget, 'inset', 'auto 0px 0px auto');
    } else if (isMobileFallTour && isExpanded) {
      setImportant(widget, 'inset', 'auto 0px 0px auto');
    } else if (isMobile && pageType === 'product') {
      setImportant(widget, 'inset', 'auto 0px 8.2rem auto');
    } else if (isMobile) {
      setImportant(widget, 'inset', 'auto 0px 0.8rem auto');
    }

    return true;
  };

  const documentObserver = new MutationObserver(positionWidget);
  documentObserver.observe(document.documentElement, {
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'open', 'data-active-season'],
    subtree: true,
  });

  positionWidget();
  document.addEventListener('sticky-product-bar:visibility', positionWidget);
  window.addEventListener('resize', positionWidget);
})();
